import { useSettings } from '../context/SettingsContext';
import { DEFAULT_THEME_ID, getSiteTheme } from './siteThemes';
import { SITE_THEME_ID_STORAGE_KEY } from './theme';

/**
 * Önbellekteki şema adı.
 *
 * Ayarlar isteği dönene kadar `settings.site_theme` boştur; o anda varsayılana
 * düşülürse Merit kullanan bir sitede önce klasik kabuk çizilip hemen ardından
 * Merit kabuğuna geçilir — göze çarpan bir sıçrama olur. İlk boyamada
 * localStorage'daki son bilinen şema kullanılır.
 */
export const getCachedThemeId = () => {
  try {
    const cached = window.localStorage.getItem(SITE_THEME_ID_STORAGE_KEY);
    return cached ? getSiteTheme(cached).id : DEFAULT_THEME_ID;
  } catch {
    return DEFAULT_THEME_ID;
  }
};

/** Yürürlükteki tasarım şemasının adı. */
export const useActiveTheme = () => {
  const settings = useSettings();
  if (settings.settingsLoaded) return getSiteTheme(settings.site_theme).id;
  return getCachedThemeId();
};

export default useActiveTheme;
